export default __webpack_public_path__ + "static/media/happyFaceV2.4a9ae775.svg";